import Vue from 'vue';
import App from './App.vue';

function mountPriceCharts() {
  const mountElements = document.querySelectorAll('.price-chart-mount:not([data-v-app])');

  mountElements.forEach((mountEl) => {
    mountEl.setAttribute('data-v-app', 'true');

    const configAttr = mountEl.getAttribute('data-config');
    let config = {};

    if (configAttr) {
      try {
        config = JSON.parse(configAttr);
      } catch (e) {
        console.error('Price chart: failed to parse config:', e);
      }
    }

    new Vue({
      render: h => h(App, {
        props: {
          texts: config.texts || {},
          apiUrl: config.apiUrl || '/wp-json/price-history/v1/prices',
          defaultMetal: config.defaultMetal || 'AU',
          defaultUnit: config.defaultUnit || 'gram',
          defaultCurrency: config.defaultCurrency || 'nok',
          mobileMode: config.mobileMode || 'full'
        }
      }),
    }).$mount(mountEl);
  });
}

// Mount on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountPriceCharts);
} else {
  mountPriceCharts();
}

// Elementor frontend dynamic loading
if (window.jQuery) {
  window.jQuery(window).on('elementor/frontend/init', function() {
    if (window.elementorFrontend && window.elementorFrontend.hooks) {
      window.elementorFrontend.hooks.addAction('frontend/element_ready/ka_price_chart.default', function() {
        mountPriceCharts();
      });
    }
  });
}

// MutationObserver fallback for dynamically added elements
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(function(mutations) {
    let shouldMount = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList && node.classList.contains('price-chart-mount') ||
            node.querySelector && node.querySelector('.price-chart-mount')
          )) {
            shouldMount = true;
          }
        });
      }
    });
    if (shouldMount) {
      mountPriceCharts();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
